var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[(_vm.formType === 'financing')?_c('Financing'):(_vm.formType === 'contact')?_c('Contact'):(_vm.formType === 'affiliate')?_c('Affiliate'):(_vm.formType === 'referral')?_c('Referral'):(_vm.formType === 'teams')?_c('Teams'):(_vm.formType === 'business_card')?_c('BusinessCard'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }